'use strict'

module.exports = paragraph

var all = require('../all')

function paragraph(h, node) {
  var nodes = all(h, node)

  if (nodes.length) {
    return h(node, 'paragraph', nodes)
  }
}
